export const validateEmail = (email) => {
    if (!email) {
        return true
    }
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}


export const validatePassword = (password) => {
    var regx = new RegExp("(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])")
    return regx.test(password)
}

export const generateRandomTag = () => {
    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 20)
}